export enum AccountType {
  ABO = "BUSINESS_OWNER",
  REGISTERED = "CUSTOMER",
  MEMBER = "MEMBER",
  EMPLOYEE = "EMPLOYEE",
}

export enum RegistrationType {
  REQUIRED = "REQUIRED",
  OPTIONAL = "OPTIONAL",
}

export interface Locale {
  locale: string;
  lang: string;
}

export interface ShareRegistrationData {
  type: AccountType;
  labelKey: string;
}
export interface ShareRegistrationConfig {
  [key: string]: RegistrationType;
}

export interface Config {
  locales: Locale[];
  shareRegistrationConfig: ShareRegistrationConfig;
  shareRegistrationData: ShareRegistrationData[];
}
